import { render, staticRenderFns } from "./ArtworkFields.vue?vue&type=template&id=9b91c462&"
import script from "./ArtworkFields.vue?vue&type=script&lang=js&"
export * from "./ArtworkFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports